const countryNamesByISO = {
  in: 'India',
  us: 'United States',
  mx: 'Mexico',
  id: 'Indonesia',
  th: 'Thailand',
  my: 'Malaysia',
  vn: 'Vietnam',
  ph: 'Philippines',
  jp: 'Japan',
  gb: 'United Kingdom',
  br: 'Brazil',
  ae: 'UAE',
  sa: 'Saudi Arabia',
  de: 'Germany',
  cn: 'China',
  es: 'Spain',
  uk: 'United Kingdom',
  np: 'Nepal',
  ie: 'Ireland'
};

export default countryNamesByISO;
